import { Component, HostBinding, Input, Type, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ItemsListRowItemAComponent } from './a/a.component';
import { ItemsListRowItemIconAComponent } from './icon-a/icon-a.component';
import {
    ItemsListRowItemBase,
    ItemsListRowItemBase_data,
    ItemsListRowItemBase_head,
    ItemsListRowItemBase_ngModel,
    ItemsListRowItemBase_parentData,
} from './list-row-item-base';
import { ItemsListRowItemArrayAComponent } from './array-a/array-a.component';
import { ItemsListRowItemImageIconAComponent } from './image-icon-a/image-icon-a.component';
import { ItemsListRowItemEmailComponent } from './email/email.component';
import { ItemsListRowItemTelComponent } from './tel/tel.component';
import { ItemsListRowItemArraySpanComponent } from './array-span/array-span.component';
import { ItemsListRowItemImageIconComponent } from './image-icon/image-icon.component';
import { ItemsListElementType, ItemsListHeader } from '../../items-list-header';
import { ItemsListRowItemTagsComponent } from './tags/tags.component';
import { ItemsListRowItemDateTimeComponent } from './date-time/date-time.component';
import { ItemsListRowItemActionsComponent } from './actions/actions.component';
import { ItemsListRowItemSpanPlainComponent } from '@fi-app/components/items-list/list-row/list-row-item/span/span-plain.component';
import { ItemsListRowItemSpanChildAComponent } from '@fi-app/components/items-list/list-row/list-row-item/span/span-child-a.component';

@Component({
    selector: 'fi-items-list-row-item',
    template: '<ng-container *ngComponentOutlet="getComponentType()"></ng-container>',
    styleUrls: ['./list-row-item.component.scss'],
    providers: [
        {
            provide: ItemsListRowItemBase_data,
            useFactory: (component: ItemsListRowItemComponent) => component.data,
            deps: [ItemsListRowItemComponent],
        },
        {
            provide: ItemsListRowItemBase_parentData,
            useFactory: (component: ItemsListRowItemComponent) => component.parentData,
            deps: [ItemsListRowItemComponent],
        },
        {
            provide: ItemsListRowItemBase_head,
            useFactory: (component: ItemsListRowItemComponent) => component.head,
            deps: [ItemsListRowItemComponent],
        },
        {
            provide: ItemsListRowItemBase_ngModel,
            useFactory: (component: ItemsListRowItemComponent) => component.ngModel,
            deps: [ItemsListRowItemComponent],
        },
    ],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-row-item' },
    standalone: false,
})
export class ItemsListRowItemComponent {
    @Input() data;
    @Input() parentData;
    @Input() head: ItemsListHeader;
    @Input() elementType: Type<ItemsListRowItemBase> | string;
    @Input('settings') ngModel;
    @ViewChild('container', { read: ViewContainerRef, static: false }) container: ViewContainerRef;

    @HostBinding('class.right-aligned')
    get isRightAligned() {
        return (
            this.head.Properties &&
            this.head.Properties.ExtraProperties &&
            this.head.Properties.ExtraProperties.isRightAligned
        );
    }

    getComponentType(): Type<ItemsListRowItemBase> {
        if (this.elementType instanceof Type) return this.elementType;

        const et = ItemsListElementType;

        // use element types instead of conditions:
        // ArrayA instead of CcmListItemArrayA.html
        switch (this.elementType) {
            case et.ArraySpan:
                return ItemsListRowItemArraySpanComponent;
            case et.A:
                return ItemsListRowItemAComponent;
            case et.ArrayA:
                return ItemsListRowItemArrayAComponent;
            case et.ImgIconA:
                return ItemsListRowItemImageIconAComponent;
            case et.ImgIcon:
                return ItemsListRowItemImageIconComponent;
            case et.Email:
                return ItemsListRowItemEmailComponent;
            case et.Tel:
                return ItemsListRowItemTelComponent;
            case et.IconA:
                return ItemsListRowItemIconAComponent;
            case et.Tags:
                return ItemsListRowItemTagsComponent;
            case et.DateTime:
                return ItemsListRowItemDateTimeComponent;
            case et.Actions:
                return ItemsListRowItemActionsComponent;
            case et.SpanPlain:
                return ItemsListRowItemSpanPlainComponent;
            case et.SpanChildA:
                return ItemsListRowItemSpanChildAComponent;
            default:
                throw 'FI: fi-items-list-row-item: Unknown list-row-item type: ' + this.elementType;
        }
    }
}
